import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import Chart from "react-google-charts";
import img1 from "../../assets/img1.png";
import svg2 from "../../assets/svg2.svg";
import svg1 from "../../assets/svg1.svg";
import svg3 from "../../assets/sms.svg";
import LogoutArrow from "../../assets/usersDashboard/LogoutArrow.svg";
import { FiLogOut } from "react-icons/fi";
import {
  AiFillPrinter,
  AiOutlineDownload,
  AiOutlineShareAlt,
} from "react-icons/ai";
import QRCode from "qrcode.react";

import { userRequest } from "../../requestMethod";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/AuthReducer";
import { Dropdown } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Avatar } from "@chakra-ui/react";

const Dashboard = () => {
  const dispatch = useDispatch();
  const qrCodeRef = useRef(null);
  const [obj, setData] = useState({
    tp: 0,
    pr: 0,
  });

  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userData"));
  //console.log(userData._id, 'userDataIsHere');
  const [businessId, setBusinessId] = useState("");

  const fetchData = async () => {
    try {
      const activePartners = await userRequest.get(
        "/admin/partner/getAllPartners?status=Active"
      );
      const deletedPartners = await userRequest.get(
        "/admin/partner/getAllPartners?status=Requested"
      );

      setData((prev) => ({
        ...prev,
        tp: activePartners?.data?.data?.length,
        pr: deletedPartners?.data?.data?.length,
      }));
    } catch (error) {
      console.error("Error fetching partner data:", error);
    }
  };

  useEffect(() => {
    const partnerId = userData._id;
    const businessData = userRequest.get(
      `/partner/business/getBusiness?_id=${partnerId}`
    );
    console.log(businessData, "businessData");
    businessData.then((val) => setBusinessId(val.data.data));

    fetchData();
  }, []);

  const data3 = [
    ["City", ""],
    ["18-23 (60%)", 60],
    ["24-28 (35%)", 35],
    ["28-40 (15%)", 15],
  ];

  const options1 = {
    title: "Category",
    colors: ["#333333", "#15EEB0", "#8CC9E9"],
    chartArea: { left: 0, top: 0, width: "100%", height: "60%" },
    legend: {
      position: "center",
      textStyle: {
        fontSize: 8,
        fontWeight: 800,
      },
    },
  };

  const data2 = [
    ["", "This year", "Previous Year"],
    ["Jan", 1000, 400],
    ["Feb", 1170, 460],
    ["March", 660, 1120],
    ["May", 1030, 540],
    ["June", 1030, 540],
    ["July", 1030, 540],
    ["Aug", 1030, 540],
    ["Sep", 1030, 540],
    ["Oct", 1030, 540],
    ["Nov", 1030, 540],
    ["Dec", 1030, 540],
  ];
  const items = [
    {
      label: (
        <div className={styles.profileDetails}>
          <Avatar name="P" bg="blue.300" size="md" />
          <div className={styles.profilePic}>
            <p style={{ fontWeight: "700" }}>{userData.fullName}</p>
            <p style={{ fontWeight: "500", marginTop: "-1rem" }}>
              {userData.email}
            </p>
          </div>
        </div>
      ),
      key: "0",
    },

    {
      type: "divider",
    },
    {
      label: (
        <span
          className={styles.logout}
          onClick={() => {
            dispatch(logout());
            window.location.reload();
          }}
        >
          {" "}
          <FiLogOut />
          Log Out
        </span>
      ),
      key: "1",
    },
  ];
  const options2 = {
    title: "",
    legend: { position: "none" },
    hAxis: { textPosition: "none" },
    vAxis: { textPosition: "none" },
    chartArea: { left: 0, top: 0, width: "100%", height: "100%" },
    series: {
      0: { color: "#333333", bar: { groupWidth: "10%" } },
      1: { color: "#8CC9E9", bar: { groupWidth: "10%" } },
    },
  };
  const downloadQRCode = () => {
    const canvas = qrCodeRef.current.querySelector("canvas");
    const image = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = "qrcode.png";
    link.click();
  };
  const shareQRCode = () => {
    if (navigator.share) {
      navigator.share({
        title: "QR Code",
        text: "Check out this QR code!",
        url: "http://yourserver.com/qrcode",
      });
    }
  };
  const printQRCode = () => {
    const qrCodeContainer = qrCodeRef.current;
    const newWindow = window.open("", "_blank");
    newWindow.document.write(qrCodeContainer.innerHTML);
    newWindow.print();
    newWindow.close();
  };
  //////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className={styles.MainContainer}>
      <div className={styles.firstContainer}>
        <h1>Dashboard Overview</h1>
        <div>
          <select>
            <option value="">This week</option>
            <option value="">This week</option>
            <option value="">This week</option>
            <option value="">This week</option>
          </select>
          <span onClick={() => navigate("/notificationdata")}>
            <img src={img1} alt="" />
          </span>

          <span id={styles.profileImg}>
            <img src="https://aave.com/aaveSiteLogo.png" alt="" />
          </span>
          <div className={styles.logoutArrow}>
            <Dropdown
              menu={{
                items,
              }}
            >
              <Link onClick={(e) => console.log(e)}>
                <img src={LogoutArrow} alt="" />
              </Link>
            </Dropdown>
          </div>
        </div>
      </div>

      <div className={styles.cards}>
        <div className={styles.cardsInner}>
          <div className={styles.card}>
            <div className={styles.cardIcon}>
              <img src={svg1} alt="" />
            </div>
            <div className={styles.cardTitle}>
              <p>Impressions</p>
              <p>{obj.tp ? obj.tp : 0}</p>
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardIcon}>
            <img src={svg2} alt="" />
            </div>
            <div className={styles.cardTitle}>
              <p>Clicks</p>
              <p>{obj.pr ? obj.pr : 0}</p>
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.cardIcon}>
              <img src={svg3} alt="" />
            </div>
            <div className={styles.cardTitle}>
              <p>Invites</p>
              <p>{obj.pr ? obj.pr : 0}</p>
            </div>
          </div>
        </div>

        <div className={styles.pieDiv}>
          <div className={styles.title}>Avg. age of Customer</div>
          <Chart
            chartType="PieChart"
            width="100%"
            height="124%"
            data={data3}
            options={options1}
          />
        </div>
      </div>
      <div className={styles.chartDiv}>
        <div className={styles.chart}>
          <div className={styles.chartHead}>
            <h3>Performance on NETME App</h3>
            <div className={styles.innerChartHead}>
              <select>
                <option value="">This Year</option>
              </select>
            </div>
          </div>

          <Chart
            chartType="Bar"
            width="100%"
            height="93%"
            data={data2}
            options={options2}
          />
        </div>
        <div className={styles.sideTable}>
          <div className={styles.printDiv}>
            <h6>Your QR code</h6>
            <span className={styles.shareIcon} onClick={shareQRCode}>
              {" "}
              <AiOutlineShareAlt /> Share
            </span>
          </div>

          <div className={styles.QrDiv} ref={qrCodeRef}>
            <QRCode
              value={businessId._id}
              style={{ height: "100%", width: "70%" }}
            />
          </div>
          <div className={styles.printDiv}>
            <span className={styles.printIcon} onClick={printQRCode}>
              {" "}
              <AiFillPrinter />
              Print
            </span>
            <span className={styles.printIcon} onClick={downloadQRCode}>
              {" "}
              <AiOutlineDownload /> Download
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
